
import { Component, Input, ViewChild, OnChanges, SimpleChanges, signal, OnInit, computed, effect } from '@angular/core';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import {
  MatTableModule,
  MatTable,
  MatTableDataSource,
} from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import {  UsuarioMySQL } from '../../../model/usuario';
import { AbstractComponent } from '../../../abstract-component';
import { MysqlDetalleUsuarioComponent } from '../mysql-detalle-usuario/mysql-detalle-usuario.component';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-mysql-lista-usuarios',
  imports: [MatFormField, MatLabel, MatTableModule, MatPaginatorModule, MatSortModule, MysqlDetalleUsuarioComponent, FormsModule],
  templateUrl: './mysql-lista-usuarios.component.html',
  styleUrl: './mysql-lista-usuarios.component.css'
})
export class MySqlListaUsuariosComponent extends AbstractComponent implements OnChanges, OnInit {
  dataSource: MatTableDataSource<UsuarioMySQL>;
  
  columnsToDisplay = ["usuario_id", "nombre", "apellidos", "direccion"];
  filaUsuarioSeleccionado?: UsuarioMySQL;
  indexfilaUsuarioSeleccionado?: number = -1;
  usuarioSignal = signal<UsuarioMySQL | undefined>(undefined);

  usersResource =  this.dhrService.usersMysqlResource;
  usersResourceValue = computed(() => {
    console.log('Users resource value updated:', this.usersResource.value());
    if (this.usersResource.isLoading()) {
      console.log('Users resource is loading...');
      this.usuarios =  [];
    } else {
      console.log('Users resource value updated:', this.usersResource.value());
      if (this.usersResource.value!=undefined) {
        this.usuarios = this.usersResource.value() as UsuarioMySQL[];
      } else {
        this.usuarios = [];
      }
      this.dataSource = new MatTableDataSource(this.usuarios);
      this.dataSource.paginator = this.paginator;
      this.dataSource.data = this.usuarios;
      
    }
    return this.usuarios
  });
  


  usersResourceState = computed(() => {
    console.log(`The query status is ${this.usersResource.status()}`);
    return this.usersResource.status();
  });
  
  usuarios: UsuarioMySQL[] = [];

  @ViewChild(MatTable) table!: MatTable<UsuarioMySQL>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  constructor() {
      super();
      this.dataSource = new MatTableDataSource(this.usuarios);
      // Si se quitase del html la referencia al signal usersResourceValue habria que descomentar el bloque effect o no se evaluaria
      
      /** 
      effect(() => {
        console.log('Effect triggered:' + this.usersResourceValue());
       
      });
      **/

      
  }
  clickedRow(arg0: any) {
    console.log(`ClickedRow: ${(<UsuarioMySQL>arg0).nombre}`);
    this.filaUsuarioSeleccionado = arg0;
    //this.usuarioSignal.set(arg0);
    this.usuarioSignal.update((elem) => {
      console.log(`usuarioSignal updated: ${elem?.nombre}`);
      return arg0;
    });

  
  }
  clickedRowSelected(fila: UsuarioMySQL):boolean {
    let retorno = false
   
    if (this.filaUsuarioSeleccionado){
      retorno = this.filaUsuarioSeleccionado==fila;
    }
    return retorno;
  }
  ngOnInit() {
    //this.dataSource.data = this.
    //this.cargarUsurios()
  }
   ngAfterViewInit(): void {
    //console.log(`ngAfterViewInit ${this.detalle.inputProperty}`);
    console.log(`**** Aplicando paginador paginador ${this.paginator}`)
    this.dataSource.paginator = this.paginator;
    this.dataSource.paginator.firstPage();
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log('*** ngOnChanges');
    console.log(this.ARRAY_MAX_ELEMENTOS);
  }
  async cargarUsurios(){
    console.log("cargarUsuarios");
  }
  cambioEnUsuarios(event: any) {
    console.log("Cambio en usuarios desde detalle usuario");
    //this.cargarUsurios();
    this.usersResource.reload()
    this.usuarioSignal.set(event);
  }
  
 
}
